"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgentConnectionStatus = void 0;
var AgentConnectionStatus;
(function (AgentConnectionStatus) {
    AgentConnectionStatus["INITIALIZING"] = "initializing";
    AgentConnectionStatus["CONNECTED"] = "connected";
    AgentConnectionStatus["OFFLINE"] = "offline";
    AgentConnectionStatus["ERROR"] = "error";
})(AgentConnectionStatus = exports.AgentConnectionStatus || (exports.AgentConnectionStatus = {}));
//# sourceMappingURL=AgentConnectionStatus.js.map